import { useEffect, useState } from 'react'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { Dialog } from '@root/shared/ui-kit'

import { openEditProfileFormModalEvent } from './atoms/reatom-edit-profile-form'
import { EditProfileForm } from './edit-profile-form'

type EditProfileModalProps = {}

export const EditProfileModal = (_props: EditProfileModalProps) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  useEffect(() => openEditProfileFormModalEvent.onCall(() => setOpen(true)), [])

  return (
    <Dialog
      variant="functional"
      open={open}
      onOpenChange={setOpen}
      describedBy={t('profile.edit_profile')}
    >
      <Dialog.Header.Functional title={t('profile.edit_profile')} />
      <Dialog.Content.Functional $variant={0}>
        <Content $variant={1}>
          <EditProfileForm onDone={() => setOpen(false)} />
        </Content>
      </Dialog.Content.Functional>
    </Dialog>
  )
}

const Content = styled(Dialog.Content.Functional)`
  width: 360px;
  padding: 20px 30px;
`
